module.exports = __webpack_public_path__ + "img/待审核.ed109708.png";